export interface IPackageGroupAPI {
  packagegroup_id?: number;
  package_ids: number[];
  package_deal_ids?: { [key: number]: string };
}

export default class PackageGroup {
  constructor(
    public packageIDs: Set<number>,
    public id: number,
    public packageDealIDs?: { [key: number]: string },
  ) {}

  public static fromObject(object: IPackageGroupAPI): PackageGroup {
    return new PackageGroup(new Set(object.package_ids), object.packagegroup_id, object.package_deal_ids);
  }

  public static fromApi(apiObject: IPackageGroupAPI | IPackageGroupAPI[]) {
    // For some reason, creating a package group returns an array
    if (Array.isArray(apiObject)) {
      return PackageGroup.fromObject(apiObject[0]);
    }
    return PackageGroup.fromObject(apiObject);
  }

  public toApi(): IPackageGroupAPI {
    return {
      package_ids: Array.from(this.packageIDs),
    };
  }
}
